/**
 * Public password-reset API (forgot password OTP flow).
 * Calls Kong `/api/v1/public/password-reset/*` — no Bearer token.
 */

import { kongBrowserFetchUrl } from "@/lib/kongApi";

/**
 * @param {Response} res
 * @returns {Promise<never>}
 */
async function throwApiError(res) {
  const body = await res.json().catch(() => ({}));
  const detail = body?.detail;
  const msg =
    (typeof detail === "object" && (detail?.message || detail?.error)) ||
    body?.message ||
    body?.error ||
    res.statusText ||
    "Request failed.";
  throw new Error(typeof msg === "string" ? msg : "Request failed.");
}

/**
 * @param {string} email
 * @returns {Promise<{ ok: boolean }>}
 */
export async function requestPasswordResetOtp(email) {
  const res = await fetch(kongBrowserFetchUrl("/api/v1/public/password-reset/request-otp"), {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) await throwApiError(res);
  return res.json();
}

/**
 * @param {{ email: string, otp: string }} params
 * @returns {Promise<{ resetToken: string }>}
 */
export async function verifyPasswordResetOtp({ email, otp }) {
  const res = await fetch(kongBrowserFetchUrl("/api/v1/public/password-reset/verify-otp"), {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp }),
  });
  if (!res.ok) await throwApiError(res);
  return res.json();
}

/**
 * @param {{ resetToken: string, newPassword: string }} params
 * @returns {Promise<{ success: boolean }>}
 */
export async function resetPasswordWithToken({ resetToken, newPassword }) {
  const res = await fetch(kongBrowserFetchUrl("/api/v1/public/password-reset/reset-password"), {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ resetToken, newPassword }),
  });
  if (!res.ok) await throwApiError(res);
  return res.json();
}
